import { LOGIN_ADMIN, LOGOUT_ADMIN, PROFILE_ADMIN, UPDATE_ADMIN_PROFILE } from './admin.type';

const initialState = {
  isAuth: false,
  admin: null,
  token: null,
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_ADMIN:
      return {
        ...state,
        isAuth: true,
        token: action.payload,
      };
    case LOGOUT_ADMIN:
      return {
        ...state,
        isAuth: false,
        admin: null,
        token: null,
      };
    case PROFILE_ADMIN:
      return {
        ...state,
        admin: action.payload,
      };
    case UPDATE_ADMIN_PROFILE:
      return {
        ...state,
        admin: action.payload,
      };
    default:
      return state;
  }
};

export default adminReducer;